module.exports = __webpack_public_path__ + "static/media/1.5ff2b660.jpg";